export * from './baSlimScroll.directive';



// WEBPACK FOOTER //
// /app/src/app/theme/directives/baSlimScroll/index.ts